/*
* Copyright Gregory Coburn 2020-2026, All Rights Reserved, See license for further details
*/
import { MatDialog } from '@angular/material/dialog';
import { MyInjector } from '@src/app/app.module';
import { uuid } from '@src/app/model/abstract-object';
import { Unit } from '@src/app/model/unit';
import { IFormAction, ActionColor } from '@src/app/shared/form/form.component';
import { OwnerChangeComponent } from '@src/app/modules/unit/unit-page/owner-change/owner-change.component';
import { timer } from 'rxjs';
import { switchMap, tap } from 'rxjs/operators';
import { MessageService } from '@src/app/shared/message.service';

export class OwnerChangeAction implements IFormAction {
    name = $localize`Transfer Unit Ownership`;
    color: ActionColor = 'primary';
    show = false;
    icon = 'transfer_within_a_station';
    approvalNeeded = false;
    disabled = false;
    approvalText = "";
    tipText = $localize `Formally record the transfer of this unit to new owners`;
    teamId: uuid;
    unit: Unit;

    action() {
        const dialog = MyInjector.instance.get(MatDialog);
        return timer(0).pipe(
            switchMap(() => dialog.open(OwnerChangeComponent, {data: {unit: this.unit, transfer: true}}).afterClosed()),
            tap(x => {
                if (x) {
                    const msgSvc = MyInjector.instance.get(MessageService);
                    msgSvc.show('Owner successfully changed to ' + x?.owner?.fullName);
                }
            })
        );
    }

    setup(unit: Unit) {
        if (unit?.teamId) {
            this.teamId = unit.teamId;
            this.show = true;
        } else {
            this.show = false;
        }
        this.unit = unit;
    }
}
